<script>
  import { createEventDispatcher } from "svelte";
  import Modal from "./Modal.svelte";
  import { HStack, VStack, Spacer } from "../component/layout";
  import { Background, Padding } from "../component/modifier";

  export let isJoin = false;
  export let isCreate = false;

  let modal = undefined;

  const dispatch = createEventDispatcher();
  const close = async () => {
    dispatch("close");
  };

  function join() {
    isJoin = true;
    isCreate = false;
    close();
  }

  function create() {
    isCreate = true;
    isJoin = false;
    close();
  }
</script>

<div class="JoinOrCreate">
  <Modal bind:modal on:close padding={false} cancelButton={false}>
    <VStack>
      <img src="images/logo_titre.svg" height="50px" alt="logo" />
      <Background color="#f0f0f0">
        <Padding>
          <h1>Que souhaitez vous faire ?</h1>
          <HStack>
            <Spacer />
            <VStack justify="space-evenly" alignment="normal">
              <Spacer />
              <button on:click={create}>Organiser un mariage</button>
              <span>ou</span>
              <button class="secondary" on:click={join}> Rejoindre un mariage </button>
              <Spacer />
            </VStack>
            <Spacer />
          </HStack>
        </Padding>
      </Background>
    </VStack>
  </Modal>
</div>

<style>
  h1 {
    font-family: "Cinzel";
    font-size: 1.5rem;
    text-align: center;
  }

  span {
    font-family: "Cinzel";
    font-size: 1.5rem;
    padding: 1rem;
    text-align: center;
  }
  button {
    background-color: var(--primary-color);
    color: #fff;
    cursor: pointer;
    border-radius: 5px;
    padding: 0.5rem;
  }
  button:hover {
    background-color: var(--primary-light-color);
  }

  button.secondary {
    background-color: white;
    color: var(--primary-dark-color);
    border-color: var(--primary-color);
  }
  button.secondary:hover {
    background-color: var(--primary-xx-light-gray-color);
  }
</style>
